import { Component } from '@angular/core';
import { FormFieldComponent } from '../form-field/form-field.component';
import { FormsDateAdapter } from '@utils/forms-date-adapter';
import { FormsDateParserFormatter } from '@utils/forms-date-parser-formatter';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-form-field-date',
  templateUrl: './form-field-date.component.html',
  styleUrls: ['./form-field-date.component.scss'],
  providers: [
    { provide: NgbDateAdapter, useClass: FormsDateAdapter },
    { provide: NgbDateParserFormatter, useClass: FormsDateParserFormatter },
  ],
})
export class FormFieldDateComponent extends FormFieldComponent {
  startDate = {
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
    day: new Date().getDate(),
  };
}
